import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { InstrumentsMenu } from "../../Common/layout/aside/aside-menu-lists/InstrumentsMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import ViewInstrument from "./selected-instrument/view-instrument/ViewInstrument";

export default function InstrumentManagementPages() {
  return (
    <>
      <AsideMenu>
        <InstrumentsMenu destination="/instruments" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <div className="py-4 px-6">
            <Switch>
              <ContentRoute path="/instruments/:instrumentId" component={ViewInstrument} />
            </Switch>
          </div>
        </Suspense>
      </Section>
    </>
  );
}
